__turbopack_context__.v({
  "select-input-box": "cHkifW_select-input-box",
  "selectField": "cHkifW_selectField",
  "suffix": "cHkifW_suffix",
});
